<script setup lang="ts">
    import { ModelType } from '~~/app/base/schemas/BaseSchema';
    import EndpointFactory from '~~/app/factories/EndpointFactory';
    import Contact from '~/app/contact/models/Contact';
    import ContactSchema from '~/app/contact/schemas/ContactSchema';

    const props = defineProps<{
        contact: Contact;
    }>();
    const comments = ref(props.contact.comments);
    const updateComments = async () => {
        const endpoint = EndpointFactory.make(ModelType.CONTACTS);
        const schema = new ContactSchema({ id: props.contact.getId(), attributes: { comments: comments.value } });
        await endpoint.withoutEvents().update(schema);
    };
</script>

<template>
    <div>
        <textarea
            v-model="comments"
            :class="$theme('form.textarea_notes')"
            :placeholder="$t('form.labels.notes')"
            @blur="updateComments"
        />
    </div>
</template>
